export default function Privacy() {
    window.location.href = 'https://www.termsfeed.com/live/39aa18dc-d4ea-410c-950f-fb2b9913c79a';
    return null;
}

